<template>
  <div>
    <v-card id="service-chat" class="cm-dialog" min-height="400px">
      <div class="header mb-0" style="padding: 16px;">
        <v-icon size="16">mdi-lock</v-icon> <small style="color: #6d6d6d"><b>CHAT INTERNO</b> (NÃO VISÍVEL PARA O CLIENTE)</small>
      </div>
      <v-divider length="1px"></v-divider>

      <v-card-text class="chat-bg">
        <ChatMessageList
          :serviceOrderId="serviceOrder.id"
          :addedMessage="addedMessage"
        />
      </v-card-text>

      <v-divider length="1px"></v-divider>
      <div class="chat-input-container">
        <textarea
          v-model="message"
          placeholder="Digite uma mensagem"
          class="message-input"
          solo
          hide-details
          rows="1"
          no-resize
        ></textarea>
        <input
          ref="fileInput"
          type="file"
          class="send-attachment"
          @change="sendFile"
          style="display: none"
          accept="image/*, video/mp4, application/pdf"
        />
        <v-icon class="icon-attach" @click="openSendFile">mdi-paperclip</v-icon>
        <v-icon
          enabled
          class="send-message"
          @click="sendTextMessage"
          color="white"
          >mdi-send</v-icon
        >
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ServiceChatAPI from '@/services/api/serviceChat';
import ChatMessageList from '@/components/ServiceOrder/Chat/ChatMessageList';

export default {
  props: {
    serviceOrder: Object,
  },
  components: { ChatMessageList },
  data() {
    return {
      message: '',
      addedMessage: false,
    };
  },
  computed: {
    ...mapGetters('Auth', ['user']),
  },
  methods: {
    async viewChat() {
      try {
        await ServiceChatAPI.view(this.serviceOrder.id);
      } catch (error) {
        console.error(error);
      }
    },
    async sendFile(event) {
      const types = {
        'image/jpeg': 'image',
        'image/jpg': 'image',
        'image/png': 'image',
        'video/mp4': 'video',
        'application/pdf': 'file',
      };
      const file = event.target.files[0];
      const formData = new FormData();

      const fileType = types[file.type] || 'file';

      formData.append('file', file);
      formData.append('user_id', this.user.id);
      formData.append('message_type', fileType);
      formData.append('user_name', this.user.name);

      if (this.user.picture_url)
        formData.append('user_photo', this.user.picture_url);

      try {
        await ServiceChatAPI.create(this.serviceOrder.id, formData);

        this.addedMessage = true;
      } catch (error) {
        console.error(error);
        this.$toast.error('Erro ao enviar arquivo');
      }
    },
    openSendFile() {
      this.$refs.fileInput.click();
    },
    async sendTextMessage() {
      if (!this.message) {
        this.$toast.error('Digite uma mensagem');
        return;
      }

      try {
        await ServiceChatAPI.create(this.serviceOrder.id, {
          message: this.message,
          user_id: this.user.id,
          message_type: 'text',
          user_name: this.user.name,
          user_photo: this.user.picture_url,
        });

        this.addedMessage = true;
        this.message = '';
      } catch (error) {
        console.error(error);
        this.$toast.error('Erro ao enviar mensagem');
      } finally {
        // eslint-disable-next-line no-return-assign
        this.$nextTick(() => (this.addedMessage = false));
      }
    },
  },
  mounted() {
    this.viewChat();
  },
};
</script>

<style lang="scss">
.cm-dialog {
  min-height: 400px;
  position: fixed;
  left: 0;
  right: 0;
  height: 100%;

  .chat-bg {
    height: calc(100vh - 292px);
  }

  .actions {
    background-color: white;
    padding: 20px 10px 20px 10px;
    position: fixed;
    bottom: 0px;
    right: 0px;
    left: 0px;
  }
}

.chat-input-container {
  display: flex;
  align-items: center;
  padding: 8px;
  background-color: #eee;
  margin: 10px;
  border-radius: 140px !important;
}

.message-input {
  flex-grow: 1;
  border: none;
  background-color: transparent;
  outline: none;
  padding: 10px 20px;
  resize: none;
  overflow: auto;
  height: 48px;
}

.icon-attach {
  cursor: pointer;
  padding: 12px;
  color: #555;
  margin-right: 4px;
}

.send-message {
  cursor: pointer;
  padding: 12px;
  background-color: #48b38b;
  border-radius: 50%;
  color: white;
}

.v-dialog {
  & ::-webkit-scrollbar {
    width: 5px;
  }

  & ::-webkit-scrollbar-thumb {
    background: #eeeeee;

    &:hover {
      background: #eeeeee;
    }
  }
}
#service-chat {

  .v-card__text {
    padding: 0 20px;
    background-image: url('~@/assets/background-chat.png');
  }
}
</style>
